import React, { useState } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import AuthorizedAction from '../../AuthorizedAction.js';
import { noResultsContent } from '../../EmptyStates.jsx';
import LastUpdateIcon from '../../icons/LastUpdateIcon.jsx';
import { PlusButtonIcon } from '../../icons/PlusButtonIcon.jsx';
import SubHeader from '../../SubHeader.jsx';
import ProjectHeader from '../../headers/PageHeaders/Project/ProjectHeader.jsx';
import StakeholdersActionsDropdown from './StakeholdersActionsDropdown.jsx';
import StakeholdersMap from './StakeholdersMap.jsx';
import StakeholdersTable from './StakeholdersTable.jsx';
import StakeholderEditorFieldModal from './StakeholderEditorFieldModal.jsx';
import Empty from '../../Empty.jsx';
import StakeholdersHistoryModal from './StakeholdersHistoryModal.jsx';

function Stakeholders({
  project,
  stakeholders,
  handleSearch,
  projectId,
  searchSuccess,
  searchPending,
  onDownloadReport,
  onDownloadCsv,
  onDeleteStakeholder,
  onDownloadReportStakeholder,
  isReportLoading,
  isCsvLoading,
  changeHistory,
  onAddStakeholder,
  onEditStakeholder,
}) {
  const [highlightedStakeholderId, setHighlightedStakeholderId] =
    useState(null);
  const [customEditorFieldContent, setCustomEditorFieldContent] =
    useState(null);
  const [showCustomEditorFieldModal, setShowCustomEditorFieldModal] =
    useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const onHideCustomEditorFieldModal = () => {
    setCustomEditorFieldContent(null);
    setShowCustomEditorFieldModal(false);
  };

  const onShowCustomEditorField = (title, editorData) => {
    setCustomEditorFieldContent({
      title,
      editorData,
    });
    setShowCustomEditorFieldModal(true);
  };
  const onShowHistoryModal = () => setShowHistoryModal(true);
  const onHideHistoryModal = () => setShowHistoryModal(false);

  const renderTable = () => {
    if (!stakeholders.length)
      return <Empty simplified content={noResultsContent} />;

    return (
      <StakeholdersTable
        onEditStakeholder={onEditStakeholder}
        onDeleteStakeholder={onDeleteStakeholder}
        onDownloadReportStakeholder={onDownloadReportStakeholder}
        onHoverStakeholder={setHighlightedStakeholderId}
        stakeholders={stakeholders}
        project={project}
        projectId={projectId}
        isReportLoading={isReportLoading}
        onShowCustomEditorField={onShowCustomEditorField}
      />
    );
  };

  return (
    <React.Fragment>
      <ProjectHeader project={project} />
      <SubHeader flexJustify small>
        <div className="flex">
          <h2>Stakeholder Analysis</h2>
          <strong className="header-item bordered text-muted">
            Total:&nbsp;
            <span className="text-primary">{stakeholders.length}</span>
          </strong>
          <Button
            aria-label="View last update"
            type="button"
            onClick={onShowHistoryModal}
            className="flex flex-align-center header-item btn-last-update-icon m-r-8"
          >
            <LastUpdateIcon />
          </Button>

          {changeHistory && project && (
            <StakeholdersHistoryModal
              show={showHistoryModal}
              onHide={onHideHistoryModal}
              history={changeHistory || []}
              project={project}
            />
          )}
        </div>
        <div className="flex flex-1 flex-end">
          <FormControl
            style={{ maxWidth: '540px' }}
            placeholder="Search..."
            type="text"
            className="search-icon m-r-30"
            onChange={handleSearch}
          />
          {project && project.manageProjectEntities ? (
            <div className="flex">
              <AuthorizedAction action="create" subject="stakeholder">
                <Button
                  bsStyle="success"
                  style={{ marginRight: '18px' }}
                  onClick={onAddStakeholder}
                >
                  <PlusButtonIcon />
                  Add Stakeholder
                </Button>
              </AuthorizedAction>
              <AuthorizedAction action="create" subject="stakeholder">
                <div>
                  <StakeholdersActionsDropdown
                    projectId={project.id}
                    project={project}
                    stakeholders={stakeholders}
                    onDownloadReport={onDownloadReport}
                    onDownloadCsv={onDownloadCsv}
                    isReportLoading={isReportLoading}
                    isCsvLoading={isCsvLoading}
                  />
                </div>
              </AuthorizedAction>
            </div>
          ) : null}
        </div>
      </SubHeader>

      <div>
        {renderTable()}
        <StakeholderEditorFieldModal
          show={showCustomEditorFieldModal}
          onHide={onHideCustomEditorFieldModal}
          resource={customEditorFieldContent}
        />
        <div>
          <StakeholdersMap
            highlightedStakeholderId={highlightedStakeholderId}
            stakeholders={stakeholders}
            project={project}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
export default Stakeholders;
